import React, { useEffect, useRef } from 'react'

import { Box, BoxProps } from '@mui/material';
import * as THREE from 'three';

// import {
//   INTERIOR_PANO_PENN_INIT_HFOV,
//   INTERIOR_PANO_PENN_INIT_MAXHFOV,    
//   INTERIOR_PANO_PENN_INIT_MAXYAW,
//   INTERIOR_PANO_PENN_INIT_MINHFOV,
//   INTERIOR_PANO_PENN_INIT_MINYAW,
//   INTERIOR_PANO_PENN_INIT_PITCH,
//   INTERIOR_PANO_PENN_INIT_VOFFSET,
//   INTERIOR_PANO_PENN_INIT_YAW,
// } from '~/env';

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
import { pannellum } from './pannellum_imports';
import './PanoViewer.css';
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
interface IPanoViewer extends Omit<BoxProps, 'ref'> {
  innerRef?: React.MutableRefObject<HTMLCanvasElement>;
  url?:string | undefined; 
}

export interface IPanoInstance {
  renderer: THREE.WebGLRenderer;
  camera: THREE.PerspectiveCamera;
  scene: THREE.Scene;
  wrapper: HTMLDivElement;
  location: { lat: number; lon: number };
}

export const PanoViewer = React.forwardRef<IPanoInstance, IPanoViewer>(function PanoViewer(props, ref: React.MutableRefObject<IPanoInstance>) {
  const { innerRef, sx, url, ...others } = props;
  //const wrapperRef = useRef() as React.MutableRefObject<HTMLDivElement>;
  
  //console.log('PanoViewer props: ', props)
  // Pannellum needs an ID to mount to so we need to generate a unique one for
  // each instance
  const { current: id } = useRef(
    `panorama-${Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000}`
  );

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  //const viewerTest = useRef<any>(null);
  //const viewer = useRef() as React.MutableRefObject<HTMLDivElement>;
  /*
  MY25_BRZ_Limited.m-SZF_OP13_Crystal-Black-Silica.x-CBS_Black-Red-Ultrasuede-Leather.i-BLA_03.png
  MY25_BRZ_Limited.m-SZF_OP13_Crystal-Black-Silica.x-CBS_Black-Red-Ultrasuede-Leather.i-BLA_04.png
  */

  useEffect(() => {

    // console.log('Panorama 2nd useEffect id: ', id);
    // console.log('Panorama 2nd useEffect pannellum: ', pannellum);
    // console.log('Panorama 2nd useEffect innerRef: ', innerRef);

    // console.log('Panorama 2nd useEffect props: ', props);
    // console.log('Panorama 2nd useEffect wrapperRef: ', wrapperRef );
    // console.log('Panorama 2nd useEffect wrapperRef.current: ', wrapperRef.current );
    // console.log('Panorama 2nd useEffect ref: ', ref );

    //.sample props may use
    // pannellum.viewer('farg', {
    //   autoLoad: true,
    //   panorama: 'https://pannellum.org/images/cerro-toco-0.jpg',
    //   dynamicUpdate: true,
    //   compass: false,
    //   friction: 0,
    //   mouseZoom: false,
    //   showZoomCtrl: false,
    //   showFullscreenCtrl: false,
    //   type: 'equirectangular',
    // });
    
    //sample urls
    //https://localhost:7145/api/v1/proxy/image/fimage?year=2025&vehicle=BRZ&trim=Limited.m-SZF_OP13&camera=Interior_Studio_360s&frame=3&extcolor=Ice-Silver-Metallic.x-ISM&intcolor=Black-Red-Ultrasuede-Leather.i-BLA&type=

    //https://pannellum.org/images/cerro-toco-0.jpg

    // console.log('INTERIOR_PANO_PENN_INIT_PITCH: ', INTERIOR_PANO_PENN_INIT_PITCH);
    // console.log('INTERIOR_PANO_PENN_INIT_YAW: ', INTERIOR_PANO_PENN_INIT_YAW);
    // console.log('INTERIOR_PANO_PENN_INIT_HFOV: ', INTERIOR_PANO_PENN_INIT_HFOV);
    // console.log('INTERIOR_PANO_PENN_INIT_VOFFSET: ', INTERIOR_PANO_PENN_INIT_VOFFSET);
    // console.log('INTERIOR_PANO_PENN_INIT_MINYAW: ', INTERIOR_PANO_PENN_INIT_MINYAW);
    // console.log('INTERIOR_PANO_PENN_INIT_MAXYAW: ', INTERIOR_PANO_PENN_INIT_MAXYAW);
    // console.log('INTERIOR_PANO_PENN_INIT_MINHFOV: ', INTERIOR_PANO_PENN_INIT_MINHFOV);
    // console.log('INTERIOR_PANO_PENN_INIT_MAXHFOV: ', INTERIOR_PANO_PENN_INIT_MAXHFOV);
    
    const viewer = pannellum.viewer(id, {
      'autoLoad': true,
      'type': 'equirectangular',
      'panorama': url,
      'escapeHTML':true,
      'showFullscreenCtrl':false,
      'pitch': -13,
      'yaw': 0,
      'hfov': 92,
      'vOffset':0,
      'minHfov':11.5,
      'maxHfov':92,
      // 'pitch': INTERIOR_PANO_PENN_INIT_PITCH,
      // 'yaw': INTERIOR_PANO_PENN_INIT_YAW,
      // 'hfov': INTERIOR_PANO_PENN_INIT_HFOV,
      // 'vOffset':INTERIOR_PANO_PENN_INIT_VOFFSET,
      // 'minYaw':INTERIOR_PANO_PENN_INIT_MINYAW,
      // 'maxYaw':INTERIOR_PANO_PENN_INIT_MAXYAW,
      // 'minHfov':INTERIOR_PANO_PENN_INIT_MINHFOV,
      // 'maxHfov':INTERIOR_PANO_PENN_INIT_MAXHFOV,
    });

    // var viewer = pannellum.viewer('panorama', {
    //   'type': 'equirectangular',
    //   'panorama': 'path/to/your/image.jpg',
    //   'hfov': 100 // Set initial hfov if needed
    // });
    
    function getZoomPercentage() {
      const hfov = viewer.getHfov();
      const initialHfov = 92; // Or use the initial hfov set during initialization
      const zoomPercentage = (initialHfov / hfov) * 100;
      return zoomPercentage;
    }
    
    // Example of getting and displaying the zoom percentage
    // let currentZoom = getZoomPercentage();
    // console.log('Current zoom: ' + currentZoom + '%');
    
    // Example of getting zoom on zoom change
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    viewer.on('zoomchange', function(event:any) {

      const currentZoom = getZoomPercentage();
      //getZoomPercentage();
      // const yawtest = viewer.getYaw();
      // console.log('Current yawtest: ', yawtest);

      // const yawHFOV = viewer.getHfov();
      // console.log('Current yawHFOV: ', yawHFOV);

      // const yawHFOV = viewer.getHfov();
      // console.log('Current yawHFOV: ', yawHFOV);

      //console.log('currentZoom!!!: ', currentZoom);
      const newPercentContainers = document.querySelectorAll('.percenttext');
      
      const myArray = Array.from(newPercentContainers);
      for(let p = 0; p < myArray.length; p++){
        myArray[p].innerHTML = Math.round(currentZoom).toString() + '%';
      }
    });

    // const boxes = document.querySelectorAll('.pnlm-info-box');
    // //console.log('Panorama 2nd useEffect boxes: ', boxes);
    // boxes.forEach(div => {
    //   div.remove();
    // });
        
    const controls = document.querySelectorAll('.pnlm-zoom-in');
    //console.log('Panorama 2nd useEffect controls: ', controls);
    controls.forEach(div => {
      const newDiv = document.createElement('div');
      newDiv.textContent = '100%';
      newDiv.classList.add('percenttext');
      div.insertAdjacentElement('afterend', newDiv)
    });
    
    return () => {
      viewer.destroy();
    };
  }, [id, url]);

  return (
    <Box 
      id={id} 
      sx={[{
        cursor: 'grab',
        background: 'transparent !important',
      },
      ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...others} 
    />
  );
});
